var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryAf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_7523)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_7523",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_7523)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.3333,
    width: 14.6667,
    height: 20,
    fill: "#1AB11F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H9.33333V0H0V20Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33325 20H18.6666V0H9.33325V20Z",
    fill: "#DC0D18"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M11.9999 9.33337C11.9999 8.96518 11.7014 8.66671 11.3333 8.66671C10.9651 8.66671 10.6666 8.96518 10.6666 9.33337H11.9999ZM12.3289 12.2181C12.6474 12.4029 13.0554 12.2946 13.2402 11.9761C13.4249 11.6576 13.3166 11.2497 12.9981 11.0649L12.3289 12.2181ZM15.0756 11.0199C14.7654 11.2183 14.6748 11.6305 14.8731 11.9407C15.0715 12.2509 15.4838 12.3415 15.794 12.1431L15.0756 11.0199ZM17.3333 9.33337C17.3333 8.96518 17.0348 8.66671 16.6666 8.66671C16.2984 8.66671 15.9999 8.96518 15.9999 9.33337H17.3333ZM10.6666 9.33337C10.6666 10.5664 11.3365 11.6423 12.3289 12.2181L12.9981 11.0649C12.3998 10.7177 11.9999 10.0719 11.9999 9.33337H10.6666ZM15.794 12.1431C16.7182 11.552 17.3333 10.5147 17.3333 9.33337H15.9999C15.9999 10.0411 15.6329 10.6635 15.0756 11.0199L15.794 12.1431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0001 10.6666C14.7365 10.6666 15.3334 9.7712 15.3334 8.66663C15.3334 7.56206 14.7365 6.66663 14.0001 6.66663C13.2637 6.66663 12.6667 7.56206 12.6667 8.66663C12.6667 9.7712 13.2637 10.6666 14.0001 10.6666Z",
    fill: "white",
    fillOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_7523"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryAf);
export default __webpack_public_path__ + "static/media/Country=AF.303a3d7bb7f7d2a2c8a287560496208c.svg";
export { ForwardRef as ReactComponent };